var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMercariBenefitLogo = function SvgIcMercariBenefitLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0211",
    d: "m15.095 26.913 9.283-4.646a1.93 1.93 0 0 0 1.068-1.728V9.7c0-.733-.413-1.4-1.068-1.728l-9.283-4.642a1.95 1.95 0 0 0-1.744 0L4.068 7.975A1.93 1.93 0 0 0 3 9.703v10.84c0 .733.413 1.4 1.068 1.728l9.283 4.646c.55.275 1.194.275 1.744 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DC9FF",
    d: "M21.965 14.864a5.03 5.03 0 1 0 0-10.06 5.03 5.03 0 0 0 0 10.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.087 19.03-.983-.494v-2.91c0-.853.481-1.703 1.469-1.594.926.101 1.638.923 1.861 1.46.348-.303.664-.367 1.12-.303.507.07 2.417.798 2.417 3.38v3.427l-1.077-.543v-3.212c0-.943-.574-1.728-1.351-1.821-.32-.037-.6.218-.607.772-.008.555 0 3.27 0 3.27l-.988-.498v-3.043c0-1.343-.866-1.768-1.246-1.808-.214-.025-.611.105-.611.793v3.124z"
  })));
};
export default SvgIcMercariBenefitLogo;